module.exports = __webpack_public_path__ + "img/hg.9149bc77.png";